import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { DatepickerPanelDirective } from './datepicker-panel.directive';

@Directive({
  standalone: true,
  selector: '[ttDatepickerToggle], tt-datepicker-toggle',
})
export class DatepickerToggleDirective {
  //eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('for') datepicker: DatepickerPanelDirective;

  @HostListener('click') handleClick(): void {
    this.datepicker?.open();
  }

  @HostBinding('class.tt-datepicker-toggle') ttDatepickerToggle = true;
}
